import GetArticlesListRequestModelBase from '../_generated/modelBases/get-articles-list-request-model-base';

export default class GetArticlesListRequestModel extends GetArticlesListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
